<template>
  <div class="login-page">
    <div class="login-bg" />
    <div class="content-register">
      <div class="center-block">
        <div class="row">
          <div
            class="col-lg-5 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2"
          >
            <div class="ibox">
              <div class="ibox-title clearfix">
                <img
                  src="../../assets/images/imea-logo-color.svg"
                  alt
                  class="logo-register pull-left"
                />
                <h2 class="title-register">Cria nova conta</h2>
              </div>
              <div class="ibox-content">
                <form @submit.prevent="submit()">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="form-group"
                        :class="{ 'has-error': errors.has('nome') }"
                      >
                        <label for="nome">{{ $t('name') }}</label>
                        <input
                          id="nome"
                          v-model="Nome"
                          v-validate="'required|min:2'"
                          type="text"
                          class="form-control"
                          name="nome"
                        />
                        <span v-show="errors.has('nome')" class="text-danger">
                          {{ errors.first('nome') }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div
                        class="form-group"
                        :class="{ 'has-error': errors.has('email') }"
                      >
                        <label for="email">{{ $t('email') }}</label>
                        <input
                          id="email"
                          v-model="Email"
                          v-validate="'required|email'"
                          type="text"
                          class="form-control"
                          name="email"
                        />
                        <span v-show="errors.has('email')" class="text-danger">
                          {{ errors.first('email') }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div
                        class="form-group"
                        :class="{ 'has-error': errors.has('telefone') }"
                      >
                        <label for="telefone">{{ $t('phone') }}</label>
                        <input
                          id="telefone"
                          v-model="Telefone"
                          v-validate="'required|min:2'"
                          type="text"
                          class="form-control"
                          name="telefone"
                        />
                        <span
                          v-show="errors.has('telefone')"
                          class="text-danger"
                        >
                          {{ errors.first('telefone') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="pais">{{ $t('country') }}</label>
                        <select2 :options="paisOptions" :change="setPais" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="estado">{{ $t('state') }}</label>
                        <select2
                          v-if="reloadEstado"
                          :disable="!PaisId"
                          :options="estadoOptions"
                          :change="setEstado"
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="cidade">{{ $t('city') }}</label>
                        <select2
                          v-if="reloadCidade"
                          :disable="!EstadoId"
                          :options="cidadeOptions"
                          :change="setCidade"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="form-group"
                        :class="{ 'has-error': errors.has('password') }"
                      >
                        <label for="senha">{{ $t('password') }}</label>
                        <input
                          id="senha"
                          ref="senha"
                          v-model="Password"
                          v-validate="'required|min:6'"
                          type="password"
                          class="form-control"
                          name="senha"
                        />
                        <span v-show="errors.has('senha')" class="text-danger">
                          {{ errors.first('senha') }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="confirmar" class>
                          {{ $t('password_confirm') }}
                        </label>
                        <input
                          id="confirmar"
                          ref="confirmar"
                          v-model="ConfirmPassword"
                          v-validate="'required|confirmed:senha'"
                          type="password"
                          class="form-control"
                          name="confirmar"
                        />
                        <span
                          v-show="errors.has('confirmar')"
                          class="text-danger"
                        >
                          {{ errors.first('confirmar') }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label>{{ $t('login.terms2') }}:</label>
                      <div class="checkbox">
                        <label>
                          <input v-model="ConfirmTerm1" type="checkbox" />
                          <a
                            style="color: #005628; font-weight: bold;"
                            target="_blank"
                            href="http://imea.com.br/imea-site/termo-de-uso.html"
                          >
                            {{ $t('login.terms') }}
                          </a>
                        </label>
                      </div>
                      <div class="checkbox">
                        <label>
                          <input v-model="ConfirmTerm2" type="checkbox" />
                          <a
                            style="color: #005628; font-weight: bold;"
                            target="_blank"
                            href="http://imea.com.br/imea-site/politica.html"
                            >{{ $t('login.privacy') }}</a
                          >
                        </label>
                      </div>
                    </div>
                  </div>
                  <p class="text-danger">{{ error }}</p>
                  <div class="row">
                    <div class="col-md-6">
                      <router-link
                        :to="{ name: 'login' }"
                        class="btn btn-white btn-block"
                      >
                        {{ $t('back') }}
                      </router-link>
                    </div>
                    <div class="col-md-6">
                      <button
                        :disabled="!ConfirmTerm1 || !ConfirmTerm2"
                        type="submit"
                        class="btn btn-primary btn-block"
                      >
                        {{ $t('register') }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <div class="overlay" />
      <i class="fa fa-circle-o-notch fa-spin loader" />
    </div>
  </div>
</template>

<script>
import { Select2 } from '../../shared'
import { mapActions } from 'vuex'
export default {
  name: 'UsuarioRestritaCreate',
  components: {
    Select2
  },
  created() {
    document.title = 'Criar Conta - IMEA'
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')
  },
  methods: {
    setPais({ id }) {
      this.PaisId = id
      this.EstadoId = ''
      this.CidadeId = ''
      this.refreshEstado()
      this.refreshCidade()
      this.estadoOptions = {
        placeholder: this.$t('select_state'),
        url: `/estado?pais=${id}`
      }
    },
    setEstado({ id }) {
      this.EstadoId = id
      this.CidadeId = ''
      this.refreshCidade()
      this.cidadeOptions = {
        placeholder: this.$t('select_city'),
        url: `/cidade?estado=${id}`
      }
    },
    setCidade({ id }) {
      this.CidadeId = id
    },
    refreshEstado() {
      this.reloadEstado = false
      setTimeout(() => {
        this.reloadEstado = true
      })
    },
    refreshCidade() {
      this.reloadCidade = false
      setTimeout(() => {
        this.reloadCidade = true
      })
    },
    submit() {
      this.$validator
        .validateScopes()
        .then(isValid => {
          if (!isValid) return

          this.loading = true
          const Nome = this.Nome
          const Email = this.Email
          const PaisId = this.PaisId
          const EstadoId = this.EstadoId
          const CidadeId = this.CidadeId
          const Telefone = this.Telefone
          const Password = this.Password
          const ConfirmPassword = this.ConfirmPassword
          this.submitData({
            Nome,
            Email,
            PaisId,
            EstadoId,
            CidadeId,
            Telefone,
            Password,
            ConfirmPassword
          })
            .then(() => {
              this.$router.push({ name: 'registro-confirm' })
              this.$analytics.logEvent('user_registered')
            })
            .catch(err => {
              this.loading = false
              const { response } = err
              if (response && response.data) {
                this.error = response.data.Message
              } else {
                this.error =
                  'Ocorreu um erro ao realizar seu cadastro. Verifique os dados e tente novamente!'
              }
            })
        })
        .catch(() => {})
    },
    ...mapActions('usuarioRestrita/create', ['submitData'])
  },
  data() {
    return {
      loading: false,
      error: '',
      Nome: '',
      Email: '',
      PaisId: '',
      EstadoId: '',
      CidadeId: '',
      Telefone: '',
      Password: '',
      ConfirmPassword: '',
      ConfirmTerm1: false,
      ConfirmTerm2: false,
      reloadEstado: true,
      reloadCidade: true,

      paisOptions: {
        placeholder: this.$t('select_country'),
        url: '/pais'
      },
      estadoOptions: {
        placeholder: this.$t('select_state'),
        url: '/estado'
      },
      cidadeOptions: {
        placeholder: this.$t('select_city'),
        url: '/cidade'
      }
    }
  }
}
</script>
